
import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config';

export async function getTakingCarDetails(tcmId) {
  const result = await axios
    .get(
      `${REACT_APP_API}/api/takingCarManagment/takingCarManagmentRawQuery/${tcmId}`
    )

  return result?.data
}
